import { render, staticRenderFns } from "./FinalExamKioskView.vue?vue&type=template&id=2a7304ac"
import script from "./FinalExamKioskView.vue?vue&type=script&lang=js"
export * from "./FinalExamKioskView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports